import React from 'react'
import { useIntl } from 'react-intl'
import withAuth from '../../../components/withAuth'
import LoanDocumentsContent from './LoanDocumentsContent'
import Page from '../../../components/Page'

const LoanDocuments = () => {
	const { formatMessage } = useIntl()
	return (
		<Page
			page="documents"
			isFullWidth
			breadcrumbs={[
				{
					label: formatMessage({ id: 'breadcrumbs.documents' }),
					value: 'documents',
				},
			]}
		>
			<LoanDocumentsContent />
		</Page>
	)
}

export default withAuth(LoanDocuments)
